<template>
  <intersect @enter="animate = true">
    <div class="news-and-media fadeUp" :class="animate ? 'animate' : ''">
      <div class="container">
        <div class="top" v-if="_.get(itemData, 'conf.useHeader') == 1">
          <h3 class="noto-semibold ttl">
            {{ _.get(itemData, "conf.header.title") }}
          </h3>
          <a
            :href="_.get(itemData, 'conf.header.full_list_url')"
            v-if="_.get(itemData, 'conf.header.full_list_title')"
            class="noto-demibold view-all"
            >{{ _.get(itemData, "conf.header.full_list_title") }}</a
          >
        </div>

        <div class="txt" v-if="_.get(itemData, 'conf.useHeader') == 1">
          {{ _.get(itemData, "conf.header.teaser") }}
        </div>

        <div class="list">
          <!--  {{-- რომელიც იქნება შიდა გვერდზე ვიდეო, აქ უნდა დავადოთ კლასი video, რომ შესაბამისი აიკონი გამოვიტანო, ვიდეო ირთვება შიდა გვერდზე --}} -->

          <router-link
            :to="$store.getters.getSingleUrl(item, 1)"
            class="news-media-block"
            v-for="(item, index) in itemData.data"
            :key="index"
          >
            <div class="img-box">
              <picture>
                <source
                  media="(max-width: 767px)"
                  :srcset="_.get(item, 'images.0.devices.mobile')"
                />
                <source
                  media="(max-width: 1023px)"
                  :srcset="_.get(item, 'images.0.devices.tablet')"
                />
                <img
                  :src="_.get(item, 'images.0.devices.desktop')"
                  class="img-absolute scale-anim"
                  :class="animate ? 'animate' : ''"
                  alt
                />
              </picture>
              <div class="img-layer"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="66.004"
                height="66"
                viewBox="0 0 66.004 66"
              >
                <path
                  id="Subtraction_152"
                  data-name="Subtraction 152"
                  d="M-16458,1017a32.794,32.794,0,0,1-12.846-2.593,32.9,32.9,0,0,1-10.49-7.073,32.862,32.862,0,0,1-7.072-10.49A32.783,32.783,0,0,1-16491,984a32.773,32.773,0,0,1,2.594-12.844,32.859,32.859,0,0,1,7.072-10.489,32.9,32.9,0,0,1,10.49-7.072A32.8,32.8,0,0,1-16458,951a32.8,32.8,0,0,1,12.846,2.593,32.9,32.9,0,0,1,10.49,7.072,32.869,32.869,0,0,1,7.072,10.489A32.773,32.773,0,0,1-16425,984a32.784,32.784,0,0,1-2.594,12.846,32.873,32.873,0,0,1-7.072,10.49,32.9,32.9,0,0,1-10.49,7.073A32.794,32.794,0,0,1-16458,1017Zm-5.068-43.9a2.007,2.007,0,0,0-2.006,2.005v17.784a2.01,2.01,0,0,0,2.008,2.007,1.954,1.954,0,0,0,1-.277l15.246-8.894a1.987,1.987,0,0,0,.99-1.732,1.981,1.981,0,0,0-.99-1.724l-15.246-8.894A1.967,1.967,0,0,0-16463.066,973.1Z"
                  transform="translate(16491 -951.002)"
                  fill="#fff"
                  opacity="0.8"
                />
              </svg>
            </div>

            <span class="description" v-if="_.get(item, 'newssource')">
              <span class="noto-semibold ttl" v-if="_.get(item, 'newssource')">
                {{ _.get(item, "newssource") }}</span
              >
              <time class="noto-semibold">{{ item.updated_at }}</time>
            </span>

            <span class="description" v-if="!_.get(item, 'newssource')">
              <time class="noto-semibold" style="border-radius: 4px">{{
                getPost.updated_at
              }}</time>
            </span>

            <h2 class="noto-semibold ttl">{{ _.get(item, "title") }}</h2>

            <div class="txt">{{ _.get(item, "teaser") }}</div>

            <div class="whiteRed-btn">
              <span class="noto-semibold">{{ $fn.tr("discover more") }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import moment from "moment";
import Intersect from "vue-intersect";
export default {
  props: {
    itemData: {
      type: Object,
      require: true
    }
  },
  components: {
    Intersect
  },
  data() {
    return {
      animate: false
    };
  },
  computed: {
    getPost() {
      return this.itemData.data.map(item => {
        item.updated_at = moment(item.updated_at).format("DD MM YYYY");
        return item;
      })[0];
    }
  }
};
</script>


<style scoped>
.news-media-block {
  display: none;
}
.news-media-block:nth-child(1),
.news-media-block:nth-child(2) {
  display: flex;
}
</style>
